import React from "react";
import { Button } from "../../../ui/button";
import { Trash2 } from "lucide-react";
import { TagSuggestionItemProps } from "../types";
import { TagItem } from "./TagItem";
import { cn } from "../../../utils";

export const TagSuggestionItem: React.FC<TagSuggestionItemProps> = ({
  label,
  id,
  onClick,
  onDeleteSuggestion,
  deleteText,
  className,
  tagClassName,
  tagVariant,
}) => (
  <div
    onClick={onClick}
    className={cn(
      "bg-transparent hover:bg-purple-muted-800 rounded-sm py-1 px-2",
      className,
    )}
  >
    <div className="flex w-full items-center justify-between gap-2">
      <TagItem
        label={label}
        id={id}
        className={tagClassName}
        variant={tagVariant}
      />
      {onDeleteSuggestion && (
        <Button
          type="button"
          variant="ghost"
          className="p-0 text-xs font-normal h-[10px]"
          onMouseDown={e => e.preventDefault()}
          onClick={e => {
            e.stopPropagation();
            onDeleteSuggestion?.(id);
          }}
          aria-label={`${deleteText} ${label}`}
        >
          {deleteText || <Trash2 className="size-4" />}
        </Button>
      )}
    </div>
  </div>
);
